import React, { FC, useCallback, useMemo } from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, withRouter } from 'react-router';
import OverviewShell from '../overview_shell/OverviewShell';

const RequestsForProposalPage: FC<any> = ({ history, childRoutes }): React.ReactElement => {
	const handleTabChange = useCallback(
		(key) => {
			history.push(`/supplier/sourcing/overview/${key}`);
		},
		[history]
	);

	const checkTabActive = useCallback(
		(key) => {
			const pathname = history.location.pathname;
			return pathname.indexOf(key) !== -1;
		},
		[history.location.pathname]
	);

	const tabs = useMemo(
		() => [
			{
				key: 'all',
				name: 'All',
			},
		],
		[]
	);

	return (
		<>
			<Route
				path="/supplier/requestsForProposal/overview"
				exact={true}
				render={() => (
					<Redirect
						to={{
							pathname: `/supplier/requestsForProposal/overview/all`,
						}}
					/>
				)}
			/>
			<OverviewShell
				title="Requests for Proposal"
				tabs={tabs}
				onTabChange={handleTabChange}
				checkTabActive={checkTabActive}
				childRoutes={childRoutes}
				className="requestsForProposalPage"
			/>
		</>
	);
};

const mapStateToProps = (state, ownProps) => ({
	currentUser: state.session.currentUser,
	requestsForProposal: state.requests_for_proposal,
});

export default withRouter<any, any>(connect(mapStateToProps)(RequestsForProposalPage));
